package devxertech.com.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import devxertech.com.pages.dashboard.Dashboard


@Page
@Composable
fun HomePage() {
    val breakpoint = rememberBreakpoint()
    Box(Modifier.fillMaxSize()) {
        Dashboard()

    }
}
